/* A loss's occurrence date is a calendar date: the backend stores a Postgres date and sends it as
   "yyyy-MM-dd". It is never an instant, so nothing here goes through epoch millis or
   new Date(string) — either one reads the value in some zone and can move it a day. */

import { DateTime } from 'luxon';

const ISO = 'yyyy-MM-dd';
// What people paste: our own format, the grid's display format, and Excel's US short date.
const INPUT_FORMATS = [ISO, 'yyyy-M-d', 'MM-dd-yyyy', 'M/d/yyyy'];

export const isIsoDate = (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && DateTime.fromFormat(value, ISO).isValid;

export const toIsoDate = (value) => {
  if (value == null) return null;
  if (value instanceof Date) {
    // agDateCellEditor hands back local midnight of the picked day, so the local fields are the date.
    const picked = DateTime.fromJSDate(value);
    return picked.isValid ? picked.toISODate() : null;
  }
  const raw = String(value).trim();
  if (raw === '') return null;
  for (const format of INPUT_FORMATS) {
    const parsed = DateTime.fromFormat(raw, format);
    if (parsed.isValid) return parsed.toISODate();
  }
  // setZone keeps an offset timestamp's own calendar date rather than converting it to this browser's.
  const stamp = DateTime.fromISO(raw, { setZone: true });
  return stamp.isValid ? stamp.toISODate() : raw;
};

export const formatLossDate = (value) => {
  if (value == null || value === '') return '--';
  return isIsoDate(value) ? DateTime.fromFormat(value, ISO).toFormat('MM-dd-yyyy') : String(value);
};

// The start of that calendar day in the local zone: local midnight, or — on a DST-gap day where
// midnight doesn't exist — the first instant after it, so the Date's local calendar fields are
// always that date (which is all agDateCellEditor and toIsoDate's round trip rely on).
export const toGridDate = (value) => (isIsoDate(value) ? DateTime.fromFormat(value, ISO).toJSDate() : null);
